module.exports = __webpack_public_path__ + "static/media/dcs012.0b2b36be.png";